"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataVisibleWhen = void 0;
const query_1 = require("./query");
class DataVisibleWhen {
    static init() {
        //console.log(`DataVisibleWhen.init`);
        query_1.Z.init('[data-invisible-when]', 'hide-when-selected', element => {
            let runTest = () => {
                let unset = element.dataset.unset || 'unset';
                let selector = element.dataset.invisibleWhen;
                if (selector.indexOf('=') === -1) {
                    let test = document.querySelector(selector);
                    let original = element.style.display;
                    if (test)
                        element.style.display = 'none';
                    else {
                        element.style.display = unset;
                    }
                    if (element.style.display != original) {
                        if (!test)
                            query_1.Z.forEachFrom(element, 'input, select, textarea', (el, ix) => query_1.Z.pushNextFocusedElement(el));
                        query_1.Z.updateLayout();
                    }
                }
                else {
                    let query = document.querySelector(selector.split('=')[0]);
                    if (query) {
                        let value = selector.split('=')[1];
                        let values = value.split('|');
                        let test = false;
                        values.forEach(val => {
                            let testOne = (`${query.value}`.toLowerCase().trim() == `${val.toLowerCase().trim()}`);
                            if (testOne)
                                test = true;
                        });
                        let original = element.style.display;
                        if (test)
                            element.style.display = 'none';
                        else {
                            element.style.display = unset;
                        }
                        if (element.style.display != original) {
                            if (!test)
                                query_1.Z.forEachFrom(element, 'input, select, textarea', (el, ix) => query_1.Z.pushNextFocusedElement(el));
                            query_1.Z.updateLayout();
                        }
                    }
                }
            };
            document.addEventListener('change', ev => runTest());
            runTest();
        });
        query_1.Z.init('[data-visible-when-equals]', 'show-when-value-selected', element => {
            let runTest = () => {
                let selector = element.dataset.visibleWhenEquals;
                let testElement = document.querySelector(selector);
                let value = element.dataset.visibleWhenValue;
                let values = value.split('|');
                let test = false;
                values.forEach(val => {
                    let testOne = (`${testElement.value}`.toLowerCase().trim() == `${val.toLowerCase().trim()}`);
                    if (testOne)
                        test = true;
                });
                //let test = `${testElement.value}`.toLowerCase() == `${value}`.toLowerCase();
                let unset = element.dataset.unset || 'unset';
                let original = element.style.display;
                if (test) {
                    element.style.display = unset;
                }
                else
                    element.style.display = 'none';
                if (element.style.display != original) {
                    if (test)
                        query_1.Z.forEachFrom(element, 'input, select, textarea', (el, ix) => query_1.Z.pushNextFocusedElement(el));
                    query_1.Z.updateLayout();
                }
            };
            document.addEventListener('change', ev => runTest());
            runTest();
        });
        query_1.Z.init('[data-visible-when]', 'show-when-selected', element => {
            //console.log(`initialise data visible when`, element);
            let runTest = () => {
                let selector = element.dataset.visibleWhen;
                let unset = element.dataset.unset || 'unset';
                if (selector.indexOf('=') === -1) {
                    let test = document.querySelector(selector);
                    //console.log(`does [${selector}] exist?`);
                    let original = element.style.display;
                    if (test) {
                        element.style.display = unset;
                    }
                    else
                        element.style.display = 'none';
                    if (element.style.display != original) {
                        if (test)
                            query_1.Z.forEachFrom(element, 'input, select, textarea', (el, ix) => query_1.Z.pushNextFocusedElement(el));
                        query_1.Z.updateLayout();
                    }
                }
                else {
                    let query = document.querySelector(selector.split('=')[0]);
                    if (query) {
                        let value = selector.split('=')[1];
                        let values = value.split('|');
                        //console.log(`does [${selector}](${value}) match ${JSON.stringify(values)}?`);
                        let test = false;
                        values.forEach(val => {
                            let testOne = (`${query.value}`.toLowerCase().trim() == `${val.toLowerCase().trim()}`);
                            if (testOne)
                                test = true;
                        });
                        let original = element.style.display;
                        if (test) {
                            element.style.display = unset;
                        }
                        else
                            element.style.display = 'none';
                        if (element.style.display != original) {
                            if (test)
                                query_1.Z.forEachFrom(element, 'input, select, textarea', (el, ix) => query_1.Z.pushNextFocusedElement(el));
                            query_1.Z.updateLayout();
                        }
                    }
                }
            };
            document.addEventListener('change', ev => runTest());
            runTest();
        });
        query_1.Z.init('[data-enable-when]', 'enable-when-initialised', element => {
            let selector = element.dataset.enableWhen;
            let selection = document.querySelectorAll(selector);
            element.addEventListener('waiting-for-change', ev => {
                let enabled = true;
                selection.forEach(input => {
                    if (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) {
                        let value = `${input.value || ''}`.trim();
                        //R.logIf(this.deepLog, `[${value}]`, input);
                        let empty = !value.length;
                        if (empty)
                            enabled = false;
                    }
                });
                //R.logIf(this.deepLog, `(waiting for change: enabled? ${enabled})`);
                if (enabled)
                    element.removeAttribute('disabled');
                else
                    element.setAttribute('disabled', 'disabled');
            });
            selection.forEach((input) => {
                if (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) {
                    //R.logIf(this.deepLog, `add change listener on`, input);
                    ['input', 'keydown', 'keypress', 'change', 'focus', 'blur', 'paste'].forEach(ev => input.addEventListener(ev, ev => {
                        element.dispatchEvent(new Event('waiting-for-change'));
                        //setTimeout(() => element.dispatchEvent(new Event('waiting-for-change')), 50);
                    }));
                }
            });
        });
        query_1.Z.init('body', 'after-all-changes', el => {
            el.addEventListener('change', ev => {
                query_1.Z.afterChangeListeners();
            });
        });
    }
}
exports.DataVisibleWhen = DataVisibleWhen;
//# sourceMappingURL=visibleWhen.js.map